"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'activities.panel.all': 'Wszystkie aktywności',
    'activities.panel.telegram': 'Telegram',
    'activities.panel.whatsapp': 'WhatsApp',
    'activities.panel.noLogs': 'Brak aktywności do wyświetlenia.',
    'activities.panel.noData': 'Brak danych kanałów.',
    'activities.panel.groups': 'Grupy',
    'activities.panel.channels': 'Kanały/Grupy',
    'activities.panel.inboxes': 'Skrzynki',
    'activities.panel.trackingEnabled': 'Śledzenie włączone',
    'activities.panel.connectionActive': 'Połączenie aktywne',
    'activities.panel.critical': 'Krytyczne',
    'activities.panel.criticalDetected': 'Wykryto krytyczne',
    'activities.panel.noAlerts': 'Brak alertów',
    'activities.panel.requiresAction': 'Wymaga akcji',
    'activities.panel.spamQueue': 'Spam/Kolejka',
    'activities.panel.warning': 'Ostrzeżenie',
    'activities.panel.noWarnings': 'Brak ostrzeżeń',
    'activities.panel.status': 'Status',
    'activities.panel.status.good': 'Dobry',
    'activities.panel.status.warning': 'Zagrożenie',
    'activities.panel.status.danger': 'Krytyczny',
    'activities.panel.lastSync': 'Ostatnia synchronizacja',
    'activities.panel.neverSynced': 'Nigdy',
    'activities.panel.justNow': 'Przed chwilą',
    'activities.panel.minutesAgo': 'min temu',
    'activities.panel.hoursAgo': 'godz. temu',
    'activities.panel.daysAgo': 'dni temu',
};
